<template lang="pug">
	.app-core--text-visualizer(:class="{ 'fade-in': visible && !changing, 'fade-out': visible && changing }")
		span(v-if="!$scopedSlots['value']") {{renderedText}}
		slot(name="value")
</template>

<script>

export default {
	props: ['text', 'textKey'],
	components: {  },
	data() {
		return {
			visible: true,
			changing: 0,
			renderedText: this.text,
			renderedKey: this.textKey
		}
	},
	watch: {
		text(v) {
			if (this.renderedKey !== this.textKey) {
				this.renderedText = v;
			} else {
				if (this.renderedText !== v) {
					this.startChanging();
				}
			}
		}
	},
	computed: {

	},
	mounted() {

	},
	destroyed() {

	},
	methods: {
		startChanging() {
			this.changing = true;
			setTimeout(() => {
				this.renderedText = this.text;
				this.changing = false;
			}, 300);
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.app-core--text-visualizer {
		&.fade-in {
			animation: fade-in 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
		}

		@keyframes fade-in {
			0% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}

		&.fade-out {
			animation: fade-out 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
		}

		@keyframes fade-out {
			0% {
				opacity: 1;
			}
			100% {
				opacity: 0;
			}
		}
	}
</style>
